export enum ImageTextMode { None, Always, ImageHover, IconHover };